import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';

export const Container = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;

export const Button = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: ${RFValue(55)}px;
`;

export const Infos = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const InfoContainer = styled.View`
  margin-left: ${RFValue(12)}px;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;

export const Date = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const PaymentIconContainer = styled.View<{bgColor: string}>`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(20)}px;
  background: ${({bgColor}) => bgColor};
  align-items: center;
  justify-content: center;
`;

export const PaymentIcon = styled(MaterialIcons)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const DeleteDevice = styled.View``;

export const DeleteIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.attention};
`;

export const Values = styled.View`
  align-items: flex-end;
`;

export const Value = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(12)}px;
  margin-top: 1px;
`;
